module.exports = __webpack_public_path__ + "media/images/book-open-red-e1142eb47101b3c7faecd41a2e305972.svg";